import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Styles } from "./styles/newsletterForm.js";
import axios from "axios";
import { Constant } from "../helper/Constants.js";

// School Enquiry endpoint
const SCHOOL_ENQUIRY_URL = "https://coretest.agriquiz.in/school-enquiry";

function NewsletterForm() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    schoolName: "",
    city: "",
    message: "",
  });

  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const [statusMessage, setStatusMessage] = useState("");
  const [statusType, setStatusType] = useState("success"); // "success" | "error"

  const data = {
    secTitle: "School Tie-up Enquiry",
  };

  const isEmail = (email) =>
    /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(email);

  const validate = () => {
    const newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = "Name can't be blank";
    }

    if (!formData.email.trim()) {
      newErrors.email = "Email can't be blank";
    } else if (!isEmail(formData.email.trim())) {
      newErrors.email = "Not a valid email";
    }

    if (!formData.phone.trim()) {
      newErrors.phone = "Phone can't be blank";
    } else if (!/^[0-9]{10}$/.test(formData.phone.trim())) {
      newErrors.phone = "Enter a valid 10-digit number";
    }

    if (!formData.schoolName.trim()) {
      newErrors.schoolName = "School name can't be blank";
    }

    if (!formData.city.trim()) {
      newErrors.city = "City can't be blank";
    }

    // message is optional
    return newErrors;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // clear error for this field as user types
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatusMessage("");
    // setStatusType("success");

    // const validationErrors = validate();
    // if (Object.keys(validationErrors).length > 0) {
    //   setErrors(validationErrors);
    //   return;
    // }

    // setSubmitting(true);
    try {
      const payload = {
        contact_person_name: formData.name,
        email: formData.email,
        phone: formData.phone,
        school_name: formData.schoolName,
        position: formData.city,
        message: formData.message,
      };

      // ✅ Use the correct URL
      const resp = await axios.post(Constant.postUrls.schoolEnquiry, payload);

      setStatusType("success");
      setStatusMessage(
        resp?.data?.message || "Your enquiry has been submitted successfully!"
      );

      // Reset form after success
      setFormData({
        name: "",
        email: "",
        phone: "",
        schoolName: "",
        city: "",
        message: "",
      });
      setErrors({});
    } catch (error) {
      console.error("School enquiry error:", error);
      setStatusType("error");
      setStatusMessage(
        error?.response?.data?.message ||
          "Something went wrong. Please try again."
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Styles>
      {/* School Enquiry Section */}
      <section className="newsletter-form-area" id="schoolEnquiry">
        <Container>
          <Row>
            <Col md="12">
              <div className="newsletter-container">
                <div className="newsletter-box">
                  <Row className="align-items-center">
                    {/* LEFT: Form */}
                    <Col md="7" sm="12">
                      <div className="sec-title">
                        <h4>{data.secTitle}</h4>
                      </div>

                      <form className="form" onSubmit={handleSubmit}>
                        <Row>
                          <Col md="6" className="mb-3">
                            <p className="form-control">
                              <input
                                type="text"
                                name="name"
                                placeholder="Enter your Name"
                                value={formData.name}
                                onChange={handleChange}
                              />
                              <span className="input-msg2">
                                {errors.name || ""}
                              </span>
                            </p>
                          </Col>

                          <Col md="6" className="mb-3">
                            <p className="form-control">
                              <input
                                type="email"
                                name="email"
                                placeholder="Enter your Email"
                                value={formData.email}
                                onChange={handleChange}
                              />
                              <span className="input-msg2">
                                {errors.email || ""}
                              </span>
                            </p>
                          </Col>

                          <Col md="6" className="mb-3">
                            <p className="form-control">
                              <input
                                type="text"
                                name="phone"
                                placeholder="Enter your Phone"
                                value={formData.phone}
                                onChange={handleChange}
                              />
                              <span className="input-msg2">
                                {errors.phone || ""}
                              </span>
                            </p>
                          </Col>

                          <Col md="6" className="mb-3">
                            <p className="form-control">
                              <input
                                type="text"
                                name="schoolName"
                                placeholder="Enter School Name"
                                value={formData.schoolName}
                                onChange={handleChange}
                              />
                              <span className="input-msg2">
                                {errors.schoolName || ""}
                              </span>
                            </p>
                          </Col>

                          <Col md="6" className="mb-3">
                            <p className="form-control">
                              <input
                                type="text"
                                name="city"
                                placeholder="Enter Position"
                                value={formData.city}
                                onChange={handleChange}
                              />
                              <span className="input-msg2">
                                {errors.city || ""}
                              </span>
                            </p>
                          </Col>

                          <Col md="12" className="mb-3">
                            <p className="form-control textarea-control">
                              <textarea
                                name="message"
                                rows="3"
                                placeholder="Additional Details (optional)"
                                value={formData.message}
                                onChange={handleChange}
                              ></textarea>
                              <span className="input-msg2">
                                {errors.message || ""}
                              </span>
                            </p>
                          </Col>

                          <Col md="12" className="mt-2">
                            <button onClick={(e)=> handleSubmit(e)}>
                              <i className="las la-envelope"></i>
                              {submitting ? "Submitting..." : "Submit Enquiry"}
                            </button>
                          </Col>

                          {statusMessage && (
                            <Col md="12" className="mt-2">
                              <p
                                style={{
                                  color:
                                    statusType === "success"
                                      ? "lightgreen"
                                      : "#ffb3b3",
                                  marginBottom: 0,
                                }}
                              >
                                {statusMessage}
                              </p>
                            </Col>
                          )}
                        </Row>
                      </form>
                    </Col>

                    {/* RIGHT: Image */}
                    <Col md="5" sm="12" className="mt-4 mt-md-0">
                      <div className="school-enquiry-image text-center">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/images/schoolEnquiry.jpg"
                          }
                          style={{ borderRadius: "10px" }}
                          alt="School Enquiry"
                          className="img-fluid"
                        />
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </Styles>
  );
}

export default NewsletterForm;
  
